<div class="admin-dialog">
  <!-- Header -->
  <div class="admin-dialog__header">
    <div class="admin-dialog__header-left">
      <h2 class="admin-dialog__title" i18n="@@distributorAgent.adminDetails.title.adminInfo">管理者情報</h2>
    </div>
    <button mat-icon-button class="admin-dialog__close" (click)="onNoClick()" aria-label="Close dialog" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="admin-dialog__content">
    <form [formGroup]="distributorAgentFormGroup">

      <!-- @if (mode == Mode.disp || mode == Mode.edit || mode == Mode.create) {
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@distributorAgent.adminDetails.label.name">氏名</span>
            <span class="form-label__required">*</span>
          </div>
          <div class="admin-dialog__field-row">
            <mat-form-field appearance="outline" class="form-field form-field--half">
              <mat-label i18n="@@distributorAgent.adminDetails.label.lastName">姓</mat-label>
              <input matInput formControlName="lastName" />
              <mat-icon matSuffix class="material-icons-outlined">person</mat-icon>
              @if (adminFormGroup.get('lastName')?.hasError('required')) {
                <mat-error i18n="@@distributorAgent.adminDetails.error.required">必須項目です</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field form-field--half">
              <mat-label i18n="@@distributorAgent.adminDetails.label.firstName">名</mat-label>
              <input matInput formControlName="firstName" />
              @if (adminFormGroup.get('firstName')?.hasError('required')) {
                <mat-error i18n="@@distributorAgent.adminDetails.error.required">必須項目です</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      } -->

      <!-- @if (mode == Mode.create) {
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@distributorAgent.adminDetails.label.signInName">ユーザーID</span>
            <span class="form-label__required">*</span>
          </div>
          <mat-form-field appearance="outline" class="form-field">
            <input matInput formControlName="signInName" />
            <mat-icon matSuffix class="material-icons-outlined">badge</mat-icon>
            @if (adminFormGroup.get('signInName')?.hasError('required')) {
              <mat-error i18n="@@distributorAgent.adminDetails.error.required">必須項目です</mat-error>
            }
            @if (adminFormGroup.get('signInName')?.hasError('pattern')) {
              <mat-error i18n="@@distributorAgent.adminDetails.error.signInNamePattern">英字で始まり、英数字またはハイフンのみが使用できます</mat-error>
            }
            @if (adminFormGroup.get('signInName')?.hasError('minlength')) {
              <mat-error i18n="@@distributorAgent.adminDetails.error.minLength">8文字以上で入力してください</mat-error>
            }
            @if (adminFormGroup.get('signInName')?.hasError('maxlength')) {
              <mat-error i18n="@@distributorAgent.adminDetails.error.maxLength32">32文字以下で入力してください</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@distributorAgent.adminDetails.label.password">パスワード</span>
            <span class="form-label__required">*</span>
          </div>
          <div class="admin-dialog__field-row">
            <mat-form-field appearance="outline" class="form-field form-field--half">
              <mat-label i18n="@@distributorAgent.adminDetails.label.passwordField">パスワード</mat-label>
              <input matInput type="password" formControlName="password" />
              <mat-icon matSuffix class="material-icons-outlined">lock</mat-icon>
              @if (adminFormGroup.get('password')?.hasError('required')) {
                <mat-error i18n="@@distributorAgent.adminDetails.error.required">必須項目です</mat-error>
              }
              @if (adminFormGroup.get('password')?.hasError('pattern')) {
                <mat-error i18n="@@distributorAgent.adminDetails.error.passwordPattern">小文字、大文字、数字、記号の4種類で入力してください</mat-error>
              }
              @if (adminFormGroup.get('password')?.hasError('minlength')) {
                <mat-error i18n="@@distributorAgent.adminDetails.error.minLength">8文字以上で入力してください</mat-error>
              }
              @if (adminFormGroup.get('password')?.hasError('maxlength')) {
                <mat-error i18n="@@distributorAgent.adminDetails.error.maxLength64">64文字以下で入力してください</mat-error>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field form-field--half">
              <mat-label i18n="@@distributorAgent.adminDetails.label.passwordConfirm">パスワード再入力</mat-label>
              <input matInput type="password" formControlName="password_confirm" />
              @if (adminFormGroup.get('password_confirm')?.hasError('required')) {
                <mat-error i18n="@@distributorAgent.adminDetails.error.required">必須項目です</mat-error>
              }
              @if (adminFormGroup.get('password_confirm')?.hasError('pattern')) {
                <mat-error i18n="@@distributorAgent.adminDetails.error.passwordPattern">小文字、大文字、数字、記号の4種類で入力してください</mat-error>
              }
              @if (adminFormGroup.get('password_confirm')?.hasError('minlength')) {
                <mat-error i18n="@@distributorAgent.adminDetails.error.minLength">8文字以上で入力してください</mat-error>
              }
              @if (adminFormGroup.get('password_confirm')?.hasError('maxlength')) {
                <mat-error i18n="@@distributorAgent.adminDetails.error.maxLength64">64文字以下で入力してください</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      } -->

      <!-- @if (mode == Mode.invite || mode == Mode.create) { -->
        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@distributorAgent.adminDetails.label.email">メールアドレス</span>
            <span class="form-label__required">*</span>
          </div>
          <mat-form-field appearance="outline" class="form-field">
            <input matInput type="email" formControlName="email" />
            <mat-icon matSuffix class="material-icons-outlined">mail</mat-icon>
            @if (distributorAgentFormGroup.get('email')?.hasError('required')) {
              <mat-error i18n="@@distributorAgent.adminDetails.error.required">必須項目です</mat-error>
            }
            @if (distributorAgentFormGroup.get('email')?.hasError('email')) {
              <mat-error i18n="@@distributorAgent.adminDetails.error.emailFormatInvalid">メールアドレスのフォーマットが誤っています</mat-error>
            }
          </mat-form-field>
        </div>
      <!-- } -->

      <!-- @if (mode == Mode.create || mode == Mode.edit || mode == Mode.disp) {
        <div class="admin-dialog__divider"></div>
        <div class="admin-dialog__field-row">
          <div class="admin-dialog__section" style="flex: 1;">
            <div class="form-label form-label--small">
              <span class="form-label__text" i18n="@@distributorAgent.adminDetails.label.birthDate">生年月日</span>
            </div>
            <mat-form-field appearance="outline" class="form-field">
              <input matInput formControlName="birthDate" placeholder="YYYY/MM/DD" i18n-placeholder="@@distributorAgent.adminDetails.placeholder.birthDate" />
              <mat-icon matSuffix class="material-icons-outlined">cake</mat-icon>
              @if (adminFormGroup.get('birthDate')?.hasError('required')) {
                <mat-error i18n="@@distributorAgent.adminDetails.error.required">必須項目です</mat-error>
              }
              @if (adminFormGroup.get('birthDate')?.hasError('pattern')) {
                <mat-error i18n="@@distributorAgent.adminDetails.error.dateFormatInvalid">存在する日付をYYYY/MM/DDの形式で入力してください</mat-error>
              }
            </mat-form-field>
          </div>
          @if (mode == Mode.create) {
            <div class="admin-dialog__section" style="flex: 1;">
              <div class="form-label form-label--small">
                <span class="form-label__text" i18n="@@distributorAgent.adminDetails.label.sex">性別</span>
              </div>
              <mat-radio-group formControlName="sex" class="form-radio-group">
                @for (option of sexOptions; track option) {
                  <mat-radio-button [value]="option.value" color="primary">{{ option.display }}</mat-radio-button>
                }
              </mat-radio-group>
              @if (adminFormGroup.get('sex')?.hasError('required')) {
                <mat-error i18n="@@distributorAgent.adminDetails.error.required">必須項目です</mat-error>
              }
            </div>
          }
        </div>
      } -->

      <div class="admin-dialog__divider"></div>

      <!-- Roles -->
      <!-- <div class="admin-dialog__section">
        <div class="form-label">
          <span class="form-label__text" i18n="@@distributorAgent.adminDetails.label.roles">権限</span>
        </div>
        <div class="role-checkboxes">
          @for (role of common.sectionGroupAdminRoles; track role.code) {
            <label class="role-checkbox">
              <mat-checkbox [formControlName]="role.code" color="primary"></mat-checkbox>
              <span class="role-checkbox__label">{{ role.desc }}</span>
            </label>
          }
        </div>
      </div> -->

      <!-- @if (mode == Mode.disp || mode == Mode.edit) {
        <div class="admin-dialog__divider"></div>

        <div class="admin-dialog__section">
          <div class="form-label">
            <span class="form-label__text" i18n="@@distributorAgent.adminDetails.label.status">ステータス</span>
          </div>
          <mat-radio-group formControlName="status" class="form-radio-group">
            @for (st of common.Status; track st) {
              <mat-radio-button [value]="st.code.toUpperCase()" color="primary">{{ st.desc }}</mat-radio-button>
            }
          </mat-radio-group>
        </div>

        <div class="admin-dialog__field-row">
          <div class="admin-dialog__section" style="flex: 1;">
            <div class="form-label form-label--small">
              <span class="form-label__text" i18n="@@distributorAgent.adminDetails.label.accountId">アカウントID</span>
            </div>
            <mat-form-field appearance="outline" class="form-field">
              <input matInput formControlName="userId" placeholder="--" i18n-placeholder="@@distributorAgent.adminDetails.placeholder.accountId" />
              <mat-icon matSuffix class="material-icons-outlined">badge</mat-icon>
            </mat-form-field>
          </div>
          <div class="admin-dialog__section" style="flex: 1;">
            <div class="form-label form-label--small">
              <span class="form-label__text" i18n="@@distributorAgent.adminDetails.label.assignedDate">管理者 開始日</span>
            </div>
            <mat-form-field appearance="outline" class="form-field">
              <input matInput formControlName="assignedDate" placeholder="--/--/--" i18n-placeholder="@@distributorAgent.adminDetails.placeholder.assignedDate" />
              <mat-icon matSuffix class="material-icons-outlined">calendar_today</mat-icon>
            </mat-form-field>
          </div>
        </div>
      } -->

    </form>
  </div>

  <!-- Footer -->
  <div class="admin-dialog__footer">
    <!-- @if (!changesMade) { -->
      <button mat-stroked-button (click)="onNoClick()">
        <span i18n="@@distributorAgent.adminDetails.button.close">閉じる</span>
      </button>
    <!-- } @else {
      <button mat-stroked-button color="warn" (click)="onNoClick()">
        <span i18n="@@distributorAgent.adminDetails.button.discard">破棄</span>
      </button>
    } -->
    <button mat-flat-button color="primary" (click)="onEditOrUploadClicked()">
      <span i18n="@@distributorAgent.adminDetails.button.action">招待</span>
    </button>
  </div>
</div>
